import * as React from 'react';
import { withRouter } from 'react-router';
import * as queryString from 'query-string';

function withSortByQuery(WrappedComponent) {
    return withRouter(class TestHoc extends React.Component<any, any> {
        constructor(props, context) {
            super(props, context);
        }
        
        callbackDirectionChange(direction: string) {
            this.updateQuery(null, null, null, direction);
        }

        callbackPageChange(page: number) {
            this.updateQuery(null, page, null, null);
        }

        callbackSortChange(sort: string) {
            this.updateQuery(null, null, sort, null);
        }

        updateQuery(search: { searchText: string } | null, page: number | null, sort: string | null, dir: string | null) {

            const currentQueryString = queryString.parse(this.props.location.search);

            // drop the search text if it is empty so it doesn't cause a double search for nothing on load
            const newSearchText = currentQueryString.search !== '' ? currentQueryString.search : undefined;
            const newSort = currentQueryString.sort !== '' ? currentQueryString.sort : undefined;

            // presume there was no change if null, otherwise update to new value (which may be undefined)
            const newQueryString = {
                dir: dir === null ? currentQueryString.dir : dir,
                search: search === null ? newSearchText : search.searchText,
                sort: sort === null ? newSort : sort,
                page: page === null ? currentQueryString.page : page
            }

            const query = queryString.stringify(newQueryString);

            this.props.history.push({
                pathname: this.props.location.pathname,
                search: '?' + query
            });
        }

        render() {
            const queryParams = queryString.parse(this.props.location.search);

            const searchPage = queryParams.page ? Number(queryParams.page) : this.props.defaultPage;
            const searchSort = queryParams.sort ? this.props.dataSortOptions.find(s => s.value === queryParams.sort.toUpperCase()) : this.props.defaultSort;

            return <WrappedComponent 
                callbackDirectionChange={this.callbackDirectionChange.bind(this)}
                callbackPageChange={this.callbackPageChange.bind(this)}
                callbackSortChange={this.callbackSortChange.bind(this)}
                defaultSortDirection={queryParams.dir}
                defaultPage={searchPage}
                defaultSort={searchSort}
                {...this.props}
            > {this.props.children}
            </WrappedComponent>
        };
    })
}

export default withSortByQuery